import axios from 'axios'
import config from '../config'
import {JsonHeaders} from '../constants';

export default {
    getOffers(currentPage, perPage, offer, user_id, archiveStatus) {
        let parameters = {
            _page: currentPage,
            itemsPerPage: perPage,
            name: offer,
            "user.id": user_id
        };
        if (archiveStatus !== 'all') {
            parameters['archive[exists]'] = archiveStatus;
        }
        return axios.get(config.publicPath + 'offers',
            {
                params: parameters,
                headers: JsonHeaders
            });
    },
    getOfferSelect() {
        return axios.get(config.publicPath + 'offers', {
            params: {'groups[]': 'select', 'pagination': false, 'archive[exists]': false},
            headers: JsonHeaders
        });
    },
    addOffer(formData) {
        return axios.post(config.publicPath + 'offers', formData, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            },
        });
    },
    archiveOffer(id) {
        return axios.post(config.publicPath + 'offers/archive/' + id, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            },
        });
    },
    getOffer(id) {
        return axios.get(config.publicPath + 'offers/' + id, {
            headers: JsonHeaders
        });
    },
    updateOffer(id, formData) {
        return axios.put(config.publicPath + 'offers/' + id, formData, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            },
        });
    },
}
